module.exports = __webpack_public_path__ + "img/maas_bg4.db9b52dc.png";